---
nb:
  errors:
    messages:
      after: må være etter %{restriction}
      before: må være før %{restriction}
      invalid_date: er ikke en gyldig dato
      invalid_datetime: er ikke en gyldig dato/klokkeslett
      invalid_time: er ikke et gyldig klokkeslett
      is_at: må være %{restriction}
      on_or_after: må være på eller etter %{restriction}
      on_or_before: må være på eller før %{restriction}
